import { Alert, AlertIcon, Box, Button, Container, HStack, Img, Input, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Spinner, Text, useColorModeValue, useDisclosure, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DesktopNav from '../components/layout/Navbar/DesktopNav/DesktopNav';
import algo from '../components/images/Icons/algo.svg';
import usdc from '../components/images/Icons/usdc.png';
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { API_URL } from '../url'
import axios from 'axios';
import algosdk, { getApplicationAddress } from 'algosdk';
import MyAlgoConnect from "@randlabs/myalgo-connect";
import { myAlgoWalletInfo } from '../components/redux/actions';
import Header from '../components/header/Header';


function LiquidityNew(props) {
    const bg = useColorModeValue("whiteAlpha.900", "whiteAlpha.100");
    const algoAdd = useSelector(state => state.token.myAlgoAddress);
    const algoBalance = useSelector(state => state.token.myAlgoBalance);
    const location = useLocation();
    const [liquidityAsset1, setLiquidityAsset] = useState()
    const [input1, setInput1] = useState(0);
    const [input2, setInput2] = useState(0);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [success, setSuccess] = useState(false);
    const [input1_response, set_Iput1_response] = useState();
    const [input2_response, set_Iput2_response] = useState();
    const [myAlgoAllAsset, setAllAsset] = useState();
    const [pool_amount, setPool] = useState();
    const [updatePool, setUpdatePool] = useState();
    const [algoAmount, setAlgo] = useState();
    const [usdcAmount, setUsdc] = useState();
    console.log(location.state);
    const pool_token = useSelector(state => state.token.borrow_app_id);
    const dispatch = useDispatch();
    const issued_liquidity = input1_response ? input1_response.data.pool_info.issued_liquidity : 0;
    console.log(issued_liquidity);
    useEffect(() => {
        const updateAccInfo = async () => {
            let accInfo = {};
            await axios(`${API_URL}swap/accountInfo?address=` + algoAdd)
                .then(response => {

                    if (response.status === 200) {
                        accInfo = response.data.clientInfo.assets;
                        //console.log(accInfo);
                        setAllAsset(accInfo);

                        // const address = accInfo.clientInfo.address;
                        // const amount = accInfo.clientInfo.amount / 1000000;
                        // dispatch(myAlgoWalletInfo({
                        //     algoAddress: address,
                        //     algoBalance: amount
                        // }));

                    }

                })
                .catch(error => {
                    console.error("Error fatching data", error);
                })
        }


        updateAccInfo();

        const pool_amount_func = async () => {
            const poolAddress = location.state ? location.state.pool_address : 62401500;
            console.log(poolAddress);
            const algodClient = new algosdk.Algodv2("", 'https://node.testnet.algoexplorerapi.io', '');

            const escrowAddress = await getApplicationAddress(poolAddress);


            let accountInfo = await algodClient.accountInformation(escrowAddress).do();

            // console.log(accountInfo);return 0;

            console.log("Account balance: %d microAlgos", accountInfo.amount);

            let accountAmount = algosdk.microalgosToAlgos(accountInfo.amount)
            console.log(accountAmount * 1000000);
            setPool(accountAmount);

        }
        pool_amount_func();

        const exchange_for_algo_to_usdc = () => {
            const token2 = 10458941;
            const token1 = 0;
            const amount = 1;
            axios.get(`${API_URL}swap/poolInfo?address=` + algoAdd + '&asset1=' + token2 + '&asset2=' + token1 + '&asset2_amount=' + amount)
                .then(function (response) {
                    console.log(response);
                    const val2 = response.data.Asset2_price_perAsset1.toFixed(2);
                    setAlgo(val2);
                    //console.log(val2);
                })
        }

        const exchange_for_usdc_to_algo = () => {
            const token2 = 0;
            const token1 = 10458941;
            const amount = 1;
            axios.get(`${API_URL}swap/poolInfo?address=` + algoAdd + '&asset1=' + token2 + '&asset2=' + token1 + '&asset2_amount=' + amount)
                .then(function (response) {
                    console.log(response);
                    const val2 = response.data.Asset2_price_perAsset1.toFixed(2);
                    setUsdc(val2);
                    //console.log(val2);
                })
        }

        exchange_for_algo_to_usdc();
        exchange_for_usdc_to_algo();

    }, []);
    console.log(pool_amount);
    let id1 = location.state ? location.state.id1 : 10458941;
    console.log(id1);
    const asset1 = myAlgoAllAsset != null ? myAlgoAllAsset.find(asset => asset["asset-id"] == id1) : null;
    console.log(asset1);
    //console.log(location.state.id1);

    const handleInput1 = async (e) => {
        e.preventDefault();
        console.log(e.target.value);
        if (!e.target.value) {
            setInput1(0)
            setInput2(0);
        } else {
            const token2 = location.state ? location.state.id1 : "10458941";
            const token1 = location.state ? location.state.id0 : "0";
            await setInput1(e.target.value);
            //await setLiquidityInput_1(e.target.value);
            //console.log(asset1_Amount);
            axios.get(`${API_URL}swap/poolInfoMint?address=` + algoAdd + '&asset1=' + token2 + '&asset2=' + token1 + '&asset2_amount=' + e.target.value)
                .then(function (response) {
                    console.log(response);
                    set_Iput1_response(response);
                    const val2 = response.data.Asset2_price_perAsset1.toFixed(2);
                    setInput2(val2);
                    setLiquidityAsset(response.data.pool_info.liquidity_asset_id);
                    console.log("liquidity1" + liquidityAsset1);

                    // setInputTwoInfo(response.data.Asset2_price_perAsset1_worst_case);
                })
        }


    }
    const handleInput2 = async (e) => {
        e.preventDefault();
        console.log(e.target.value);
        if (!e.target.value) {
            setInput1(0)
            setInput2(0);
        } else {
            const token2 = location.state ? location.state.id1 : "10458941";
            const token1 = location.state ? location.state.id0 : "0";
            await setInput2(e.target.value);
            //await setLiquidityInput_1(e.target.value);
            //console.log(asset1_Amount);
            axios.get(`${API_URL}swap/poolInfoMint?address=` + algoAdd + '&asset1=' + token1 + '&asset2=' + token2 + '&asset2_amount=' + e.target.value)
                .then(function (response) {
                    console.log(response);
                    set_Iput2_response(response);
                    const val2 = parseInt(response.data.Asset2_price_perAsset1.toFixed(2));
                    setInput1(val2);
                    setLiquidityAsset(response.data.pool_info.liquidity_asset_id);
                    console.log("liquidity1" + liquidityAsset1);
                    // setInputTwoInfo(response.data.Asset2_price_perAsset1_worst_case);
                })
        }


    }
    const addLiquidity = async () => {
        onOpen();
        const token2 = location.state ? location.state.id1 : "10458941";
        const token1 = location.state ? location.state.id0 : "0";
        var optinResult = "";
        // await axios('http://192.168.0.135:12000/swap/checkOptin?address=' + address)
        await axios(`${API_URL}swap/checkAssetOptin?address=` + algoAdd + '&assetId=' + token2)
            .then(response => {
                if (response.status === 200) {

                    console.log(response);
                    console.log("token2" + token2);
                    optinResult = response.data;
                    console.log(optinResult);
                }


            })
            .catch(error => {
                console.error("Error fatching data", error);
                //setError(error);
            })
        //
        if (optinResult.optinInResult) {
            console.log("Hello1");
            var optinResultForLiquidityAsset = "";
            // await axios('http://192.168.0.135:12000/swap/checkOptin?address=' + address)
            await axios(`${API_URL}swap/checkAssetOptin?address=` + algoAdd + '&assetId=' + liquidityAsset1)
                .then(response => {
                    if (response.status === 200) {

                        console.log(response);
                        optinResultForLiquidityAsset = response.data.optinInResult;
                        console.log("optinResultForLiquidityAsset" + optinResultForLiquidityAsset);
                    }


                })
                .catch(error => {
                    console.error("Error fatching data", error);
                    //setError(error);
                })
            if (optinResultForLiquidityAsset) {
                console.log("helllooo");
                const algodClient = new algosdk.Algodv2("", 'https://node.testnet.algoexplorerapi.io', '');

                let data = {};
                await axios(`${API_URL}swap/poolInfo?address=` + algoAdd + '&asset1=' + token2 + '&asset2=' + token1 + '&asset2_amount=' + input1)
                    .then(response => {


                        if (response.status === 200) {
                            data = response.data;
                            console.log(response);

                        }


                    })
                    .catch(error => {
                        console.error("Error fatching data", error);

                    })

                // const headers = {
                //     "X-API-Key": "1nYJyGUcqI4QNR7ChogoU2839CD3Osh7a6EVEBtv",
                // }
                // const algodClient = new algosdk.Algodv2(headers,'https://testnet-algorand.api.purestake.io/ps2', "");

                // const validator_app_id = 62368684; pool_token
                const validator_app_id = 62368684;
                const asset1_id = data.pool_info.asset1_id;
                const asset2_id = data.pool_info.asset2_id;


                const liquidity_asset_id = data.pool_info.liquidity_asset_id;
                //assetOptin(liquidity_asset_id);
                //console.log("liquidity_asset_id" + liquidity_asset_id);
                //return 0;
                const asset_in_id = data.asset_in_id;
                const asset_out_id = data.asset_out_id;
                const asset_in_amount = data.asset_in_amount;
                const asset_out_amount = data.asset_out_amount;
                // const swap_type = "fixed-input";
                const sender = algoAdd;
                const suggested_params = await algodClient.getTransactionParams().do();
                const pool_address = data.pool_info.address;

                const note = new Uint8Array(Buffer.from('fee', 'utf8'));
                const note2 = new Uint8Array(Buffer.from('mint', 'utf8'));

                alert(input2);
                const txn1 = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
                    from: sender,
                    suggestedParams: {
                        ...suggested_params
                    },
                    to: pool_address,
                    amount: 2000,
                    note: note


                });



                const txn2 = algosdk.makeApplicationNoOpTxnFromObject({
                    from: pool_address,
                    suggestedParams: {
                        ...suggested_params
                    },
                    appIndex: validator_app_id,
                    appArgs: [note2],
                    accounts: [sender],
                    foreignAssets: [asset1_id, liquidity_asset_id],

                })


                const txn3 = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
                    from: sender,
                    suggestedParams: {
                        ...suggested_params
                    },
                    to: pool_address,
                    amount: parseInt(input2 * 1000000),
                    assetIndex: asset1_id
                })

                const txn4 = algosdk.makePaymentTxnWithSuggestedParamsFromObject({
                    from: sender,
                    suggestedParams: {
                        ...suggested_params
                    },
                    to: pool_address,
                    amount: parseInt(input1 * 1000000),



                });

                const txn5 = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
                    from: pool_address,
                    suggestedParams: {
                        ...suggested_params
                    },
                    to: sender,
                    amount: 3,
                    assetIndex: liquidity_asset_id
                })

                const txns = [txn1, txn2, txn3, txn4, txn5];



                const groupID = algosdk.assignGroupID(txns)

                // let lsig = algosdk.makeLogicSig([4, 32, 8, 1, 0, 0, 129, 180, 158, 44, 3, 4, 5, 6, 37, 36, 13, 68, 49, 9, 50, 3, 18, 68, 49, 21, 50, 3, 18, 68, 49, 32, 50, 3, 18, 68, 50, 4, 34, 13, 68, 51, 1, 0, 49, 0, 18, 68, 51, 1, 16, 33, 7, 18, 68, 51, 1, 24, 129, 172, 215, 222, 29, 18, 68, 51, 1, 25, 34, 18, 51, 1, 27, 33, 4, 18, 16, 55, 1, 26, 0, 128, 9, 98, 111, 111, 116, 115, 116, 114, 97, 112, 18, 16, 64, 0, 92, 51, 1, 25, 35, 18, 68, 51, 1, 27, 129, 2, 18, 55, 1, 26, 0, 128, 4, 115, 119, 97, 112, 18, 16, 64, 2, 59, 51, 1, 27, 34, 18, 68, 55, 1, 26, 0, 128, 4, 109, 105, 110, 116, 18, 64, 1, 59, 55, 1, 26, 0, 128, 4, 98, 117, 114, 110, 18, 64, 1, 152, 55, 1, 26, 0, 128, 6, 114, 101, 100, 101, 101, 109, 18, 64, 2, 91, 55, 1, 26, 0, 128, 4, 102, 101, 101, 115, 18, 64, 2, 121, 0, 33, 6, 33, 5, 36, 35, 18, 77, 50, 4, 18, 68, 55, 1, 26, 1, 23, 37, 18, 55, 1, 26, 2, 23, 36, 18, 16, 68, 51, 2, 0, 49, 0, 18, 68, 51, 2, 16, 33, 4, 18, 68, 51, 2, 33, 35, 18, 68, 51, 2, 34, 35, 28, 18, 68, 51, 2, 35, 33, 7, 18, 68, 51, 2, 36, 35, 18, 68, 51, 2, 37, 128, 8, 84, 77, 80, 79, 79, 76, 49, 49, 18, 68, 51, 2, 38, 81, 0, 15, 128, 15, 84, 105, 110, 121, 109, 97, 110, 80, 111, 111, 108, 49, 46, 49, 32, 18, 68, 51, 2, 39, 128, 19, 104, 116, 116, 112, 115, 58, 47, 47, 116, 105, 110, 121, 109, 97, 110, 46, 111, 114, 103, 18, 68, 51, 2, 41, 50, 3, 18, 68, 51, 2, 42, 50, 3, 18, 68, 51, 2, 43, 50, 3, 18, 68, 51, 2, 44, 50, 3, 18, 68, 51, 3, 0, 49, 0, 18, 68, 51, 3, 16, 33, 5, 18, 68, 51, 3, 17, 37, 18, 68, 51, 3, 20, 49, 0, 18, 68, 51, 3, 18, 35, 18, 68, 36, 35, 19, 64, 0, 16, 51, 1, 1, 51, 2, 1, 8, 51, 3, 1, 8, 53, 1, 66, 1, 177, 51, 4, 0, 49, 0, 18, 68, 51, 4, 16, 33, 5, 18, 68, 51, 4, 17, 36, 18, 68, 51, 4, 20, 49, 0, 18, 68, 51, 4, 18, 35, 18, 68, 51, 1, 1, 51, 2, 1, 8, 51, 3, 1, 8, 51, 4, 1, 8, 53, 1, 66, 1, 124, 50, 4, 33, 6, 18, 68, 55, 1, 28, 1, 49, 0, 19, 68, 55, 1, 28, 1, 51, 4, 20, 18, 68, 51, 2, 0, 49, 0, 19, 68, 51, 2, 20, 49, 0, 18, 68, 51, 3, 0, 51, 2, 0, 18, 68, 51, 2, 17, 37, 18, 68, 51, 3, 20, 51, 3, 7, 51, 3, 16, 34, 18, 77, 49, 0, 18, 68, 51, 3, 17, 35, 51, 3, 16, 34, 18, 77, 36, 18, 68, 51, 4, 0, 49, 0, 18, 68, 51, 4, 20, 51, 2, 0, 18, 68, 51, 1, 1, 51, 4, 1, 8, 53, 1, 66, 1, 17, 50, 4, 33, 6, 18, 68, 55, 1, 28, 1, 49, 0, 19, 68, 55, 1, 28, 1, 51, 2, 20, 18, 68, 51, 3, 20, 51, 3, 7, 51, 3, 16, 34, 18, 77, 55, 1, 28, 1, 18, 68, 51, 2, 0, 49, 0, 18, 68, 51, 2, 20, 51, 4, 0, 18, 68, 51, 2, 17, 37, 18, 68, 51, 3, 0, 49, 0, 18, 68, 51, 3, 20, 51, 3, 7, 51, 3, 16, 34, 18, 77, 51, 4, 0, 18, 68, 51, 3, 17, 35, 51, 3, 16, 34, 18, 77, 36, 18, 68, 51, 4, 0, 49, 0, 19, 68, 51, 4, 20, 49, 0, 18, 68, 51, 1, 1, 51, 2, 1, 8, 51, 3, 1, 8, 53, 1, 66, 0, 144, 50, 4, 33, 5, 18, 68, 55, 1, 28, 1, 49, 0, 19, 68, 51, 2, 0, 55, 1, 28, 1, 18, 68, 51, 2, 0, 49, 0, 19, 68, 51, 3, 0, 49, 0, 18, 68, 51, 2, 20, 51, 2, 7, 51, 2, 16, 34, 18, 77, 49, 0, 18, 68, 51, 3, 20, 51, 3, 7, 51, 3, 16, 34, 18, 77, 51, 2, 0, 18, 68, 51, 1, 1, 51, 3, 1, 8, 53, 1, 66, 0, 62, 50, 4, 33, 4, 18, 68, 55, 1, 28, 1, 49, 0, 19, 68, 51, 2, 20, 51, 2, 7, 51, 2, 16, 34, 18, 77, 55, 1, 28, 1, 18, 68, 51, 1, 1, 51, 2, 1, 8, 53, 1, 66, 0, 18, 50, 4, 33, 4, 18, 68, 51, 1, 1, 51, 2, 1, 8, 53, 1, 66, 0, 0, 51, 0, 0, 49, 0, 19, 68, 51, 0, 7, 49, 0, 18, 68, 51, 0, 8, 52, 1, 15, 67])
                let lsig = algosdk.makeLogicSig(data.byteInfo);
                console.log(lsig.address())
                // if(lsig.address()==pool_address){
                //     console.log("address matched")
                // }

                let sign2 = algosdk.signLogicSigTransactionObject(txn2, lsig);

                let sign5 = algosdk.signLogicSigTransactionObject(txn5, lsig);

                console.log("-------logicsig signed trx-------");

                console.log(sign2);


                console.log(sign5);
                onClose();
                const myAlgoConnect = new MyAlgoConnect();
                let txns2 = [txn1, txn3, txn4]

                console.log("-------Sigining tx from frontend-------");
                const signedTxn = await myAlgoConnect.signTransaction(txns2.map(txn => txn.toByte()));

                console.log(signedTxn[0])
                console.log(signedTxn[1])
                console.log(signedTxn[2])

                console.log("-------Sending tx from frontend to network-------");

                // assetOptin(liquidity_asset_id);

                let response = (await algodClient.sendRawTransaction([signedTxn[0].blob, sign2.blob, signedTxn[1].blob, signedTxn[2].blob, sign5.blob]).do());
                pool_amount_func();
                setSuccess(true);
                setTimeout(() => {
                    setSuccess(false);
                    updateAccInfo();
                    setInput1(0);
                    setInput2(0);

                }, 7000);
                // alertPopUp(true)
                // setLiquidityInput_1(0);
                // setinputTwo(0);
                // setShowInput(true);
                // setTimeout(() => {
                //     alertPopUp(false);
                //     updateAccInfo();

                // }, 7000);

                console.log("-------Sending logisig tx to network-------");
                console.log(response);

            } else {
                assetOptin(liquidityAsset1);
            }
        } else {
            assetOptin(token2);
        }
    }
    const assetOptin = async (asset_id) => {
        console.log(asset_id);
        const algodClient = new algosdk.Algodv2("", 'https://node.testnet.algoexplorerapi.io', '');
        const params = await algodClient.getTransactionParams().do();
        var note = new Uint8Array([10]);


        let sender = algoAdd;
        let recipient = sender;
        // We set revocationTarget to undefined as 
        // This is not a clawback operation
        let revocationTarget = undefined;
        // CloseReaminerTo is set to undefined as
        // we are not closing out an asset
        let closeRemainderTo = undefined;
        // We are sending 0 assets
        let amount = 0;
        let assetID = parseInt(asset_id);
        // signing and sending "txn" allows sender to begin accepting asset specified by creator and index
        let txn = algosdk.makeAssetTransferTxnWithSuggestedParams(
            sender,
            recipient,
            closeRemainderTo,
            revocationTarget,
            amount,
            note,
            assetID,
            params);



        const myAlgoConnect = new MyAlgoConnect();
        const signedTxn = await myAlgoConnect.signTransaction(txn.toByte());
        let response = algodClient.sendRawTransaction(signedTxn.blob).do();
        addLiquidity();

        console.log(response);



    }

    const updateAccInfo = async () => {
        let accInfo = {};
        await axios(`${API_URL}swap/accountInfo?address=` + algoAdd)
            .then(response => {

                if (response.status === 200) {
                    accInfo = response.data;
                    console.log(accInfo);
                    const address = accInfo.clientInfo.address;
                    const amount = accInfo.clientInfo.amount / 1000000;
                    dispatch(myAlgoWalletInfo({
                        algoAddress: address,
                        algoBalance: amount
                    }));
                    console.log(accInfo);
                    console.log(amount);
                }

            })
            .catch(error => {
                console.error("Error fatching data", error);
            })
    }
    const pool_amount_func = async () => {
        const algodClient = new algosdk.Algodv2("", 'https://node.testnet.algoexplorerapi.io', '');

        const escrowAddress = await getApplicationAddress(100305128);


        let accountInfo = await algodClient.accountInformation(escrowAddress).do();

        // console.log(accountInfo);return 0;

        console.log("Account balance: %d microAlgos", accountInfo.amount);

        let accountAmount = algosdk.microalgosToAlgos(accountInfo.amount)
        setUpdatePool(accountAmount);

    }
    console.log(updatePool);
    const issueLiquidity = input1_response ? input1_response.data.pool_info.issued_liquidity / 1000000 : 0;
    console.log(issueLiquidity);

    return (
        <>
            <Header />
            <Box minH="100vh" py="50px">
                {/* first component start from here  */}

                <Box w="100%" >
                    <Container maxW={'3xl'} mt="80px" pt="30px" borderRadius="15px" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px">
                        <HStack pb="30px">
                            <Text fontSize="14px" bgGradient='linear(to-r, #85BF47, #38B455)' color="whiteAlpha.900" _hover={{ bgGradient: 'linear(to-r, #38B455, #85BF47)' }} p="15px" borderRadius="40px"> ADD LIQUIDITY </Text>
                        </HStack>
                        <HStack justifyItems="center" justifyContent="space-between" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" borderRadius="30px" overflow="hidden" mb="20px">
                            <HStack justifyItems="center" justifyContent="space-between" w="50%" px="20px" bgColor={bg} py="8px">
                                <HStack>
                                    <Img src={location.state ? location.state.icon0 : algo} w="40px" h="40px" />
                                    <Text fontWeight="bold">{location.state ? location.state.label0 : "ALGO"}</Text>
                                    <IoIosCheckmarkCircleOutline color='green' />
                                </HStack>
                                <VStack>
                                    <Text fontWeight="bold">Balance</Text>
                                    <Text>{algoBalance}</Text>
                                </VStack>
                            </HStack>

                            <HStack justifyItems="center" justifyContent="space-between" w="50%" px="20px">
                                <Box w="35%">
                                    <Text fontWeight="bold">Total</Text>
                                </Box>
                                <Box w="65%">
                                    <Input type="number" border="none" value={input1 ?? ""} placeholder='enter amount' textAlign="right" onChange={(e) => handleInput1(e)} />
                                </Box>
                            </HStack>
                        </HStack>

                        <HStack justifyItems="center" justifyContent="space-between" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" borderRadius="30px" overflow="hidden" mb="20px">
                            <HStack justifyItems="center" justifyContent="space-between" w="50%" px="20px" bgColor={bg} py="8px">
                                <HStack>
                                    <Img src={location.state ? location.state.icon1 : usdc} w="40px" h="40px" />
                                    <VStack align="left">
                                        <Text fontWeight="bold" mb="-5px" >{location.state ? location.state.label1 : "USDC"}</Text>
                                        <Text fontWeight="500">#{location.state ? location.state.id1 : "10458941"}</Text>
                                    </VStack>
                                </HStack>
                                <VStack>
                                    <Text fontWeight="bold">Balance</Text>
                                    <Text>{asset1 ? asset1.amount / 1000000 : 0.00}</Text>
                                </VStack>
                            </HStack>

                            <HStack justifyItems="center" justifyContent="space-between" w="50%" px="20px">
                                <Box w="35%">
                                    <Text fontWeight="bold">Total</Text>
                                </Box>
                                <Box w="65%">
                                    <Input type="number" border="none" placeholder='enter amount' textAlign="right" value={input2} onChange={(e) => handleInput2(e)} />
                                </Box>
                            </HStack>
                        </HStack>

                        <HStack justifyItems="center" justifyContent="space-between" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" borderRadius="30px" overflow="hidden" p="12px" px="20px" mb="20px">
                            <Text>0.30% fee tier</Text>

                            <Button>CHANGE FEE</Button>
                        </HStack>

                        <Button w="100%" borderRadius="30px" mb="30px" bgGradient='linear(to-r, #85BF47, #38B455)' color="whiteAlpha.900" _hover={{ bgGradient: 'linear(to-r, #38B455, #85BF47)' }} py="25px" onClick={addLiquidity}>Confirm</Button>

                    </Container>

                    <Container maxW={'2xl'} py="30px" borderRadius="15px" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" >

                        <HStack px="15px" justifyItems="center" justifyContent="space-between" mb="10px">
                            <Text fontWeight="600">Exchange rate</Text>
                            <VStack>
                                <Text color="gray.400">{location.state ? location.state.exchangeRate2 : algoAmount} {location.state ? location.state.label0 : 'ALGO'} per {location.state ? location.state.label1 : 'USDC'}</Text>
                                <Text color="gray.400">{location.state ? location.state.exchangeRate1 : usdcAmount} {location.state ? location.state.label1 : 'USDC'} per {location.state ? location.state.label0 : 'ALGO'}</Text>
                            </VStack>
                        </HStack>
                        <HStack px="15px" justifyItems="center" justifyContent="space-between" mb="5px">
                            <Text fontWeight="600">Current Liquidity Tokens</Text>

                            <Text color="gray.400">{pool_amount ? pool_amount : 0.00}</Text>
                        </HStack>

                        <HStack px="15px" justifyItems="center" justifyContent="space-between" mb="5px">
                            <Text fontWeight="600">Current Pool Share</Text>

                            {/* <Text color="gray.400">{input1_response ? (input1 / input1_response.data.asset_out_amount) + (input2 / input1_response.data.asset_in_amount) + "%" : "0.00"}</Text> */}
                            <Text color="gray.400">{pool_amount ? (pool_amount / issueLiquidity) / 100 : 0}%</Text>
                        </HStack>

                        <HStack px="15px" justifyItems="center" justifyContent="space-between" mb="5px">
                            <Text fontWeight="600">New Liquidity Tokens</Text>

                            <Text color="gray.400">{updatePool ? updatePool : 0}</Text>
                        </HStack>

                        <HStack px="15px" justifyItems="center" justifyContent="space-between" mb="5px">
                            <Text fontWeight="600">New Pool Share</Text>

                            {/* <Text color="gray.400">{input1_response ? (((input1_response.data.asset_out_amount * 1000000 / input1_response.data.asset_out_amount) + (input2 * 1000000 / input1_response.data.asset_in_amount)) / 100) + "%" : "0.00"}</Text> */}

                            <Text color="gray.400">{input1_response ? ((input1_response.data.asset_in_amount / input1_response.data.pool_info.asset2_reserves) / 100) + (((input1_response.data.asset_out_amount * 1000000) / input1_response.data.pool_info.asset1_reserves) / 100) + "%" : "0.00"}</Text>
                        </HStack>
                        {success ?
                            <Alert status='success'>
                                <AlertIcon />
                                Liquidity Added Successfully. Fire on!
                            </Alert>
                            : null
                        }

                    </Container>
                    <Modal isOpen={isOpen} onClose={onClose} isCentered>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Adding Liquidity.....</ModalHeader>

                            <ModalBody alignItems="center" py="20px">
                                <HStack alignItems="center" justifyContent="space-evenly">
                                    <Spinner
                                        thickness='4px'
                                        speed='0.65s'
                                        emptyColor='gray.200'
                                        color='blue.500'
                                        h="120px"
                                        w="120px"
                                    />
                                </HStack>
                            </ModalBody>
                        </ModalContent>
                    </Modal>

                </Box>
            </Box>
        </>
    )
}

export default LiquidityNew